import { render, staticRenderFns } from "./EvaluationList.vue?vue&type=template&id=dad2de60&scoped=true&"
import script from "./EvaluationList.vue?vue&type=script&lang=js&"
export * from "./EvaluationList.vue?vue&type=script&lang=js&"
import style0 from "./EvaluationList.vue?vue&type=style&index=0&id=dad2de60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dad2de60",
  null
  
)

export default component.exports